import styled from '@emotion/styled';
import { Tabs as TabsOG,  SvgIconProps } from '@mui/material';
import Tab from '@mui/material/Tab';
import React from 'react'

interface TabsProps {
    className?: string,
    tabs: { label: string, icon: React.FC<SvgIconProps> }[]
    orientation?: "horizontal" | "vertical",
    iconPosition?: "start" | "end" | "top" | "bottom",
    handleChange: (event: React.SyntheticEvent, newPanel: number) => void,
    panel: number,
}

export default function Tabs({ 
    className, 
    tabs, 
    orientation = "horizontal", 
    iconPosition = "start", 
    handleChange,
    panel
  }
    : TabsProps) {
  return (
    <StyledTabs 
      className={className} 
      value={panel} 
      onChange={handleChange} 
      orientation={orientation}
      TabIndicatorProps={{ sx: { width: 3 }}}
    >
        {tabs.map((tab, idx) => (
            <StyledTab 
              label={tab.label} 
              icon={<tab.icon />} 
              iconPosition={iconPosition} 
            />
        ))}
    </StyledTabs>
  )
}

const StyledTab = styled(Tab)({
    color: "#FFFFFF",
    fontWeight: "400",
});

const StyledTabs = styled(TabsOG)({
  "& .Mui-selected": {
    background: "#F7C873"
  }
})